/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdFormatEnum {
  DESKTOP_FEED_STANDARD = 'DESKTOP_FEED_STANDARD',
  FACEBOOK_STORY_MOBILE = 'FACEBOOK_STORY_MOBILE',
  INSTAGRAM_REELS = 'INSTAGRAM_REELS',
  INSTAGRAM_STANDARD = 'INSTAGRAM_STANDARD',
  INSTAGRAM_STORY = 'INSTAGRAM_STORY',
  MESSENGER_MOBILE_INBOX_MEDIA = 'MESSENGER_MOBILE_INBOX_MEDIA',
  MOBILE_FEED_STANDARD = 'MOBILE_FEED_STANDARD',
  MOBILE_NATIVE = 'MOBILE_NATIVE'
}

export enum AdSetSpendModeEnum {
  sampling = 'sampling',
  scaling = 'scaling',
  stable = 'stable'
}

export enum AdSetsStateEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  CAMPAIGN_PAUSED = 'CAMPAIGN_PAUSED',
  DELETED = 'DELETED',
  IN_PROCESS = 'IN_PROCESS',
  KEYWEE_UNKNOWN = 'KEYWEE_UNKNOWN',
  PAUSED = 'PAUSED',
  WITH_ISSUES = 'WITH_ISSUES'
}

export enum AdTargetAttributeSearchPathsEnum {
  BEHAVIORS = 'BEHAVIORS',
  CITIES = 'CITIES',
  COUNTRIES = 'COUNTRIES',
  EDUCATION_MAJORS = 'EDUCATION_MAJORS',
  EDUCATION_SCHOOLS = 'EDUCATION_SCHOOLS',
  FAMILY_STATUSES = 'FAMILY_STATUSES',
  INCOME = 'INCOME',
  INTERESTS = 'INTERESTS',
  LOCALES = 'LOCALES',
  MEDIUM_GEO_AREAS = 'MEDIUM_GEO_AREAS',
  REGIONS = 'REGIONS',
  WORK_EMPLOYERS = 'WORK_EMPLOYERS',
  WORK_POSITIONS = 'WORK_POSITIONS',
  ZIPS = 'ZIPS'
}

export enum AiImageStyleTypeEnum {
  analytic_drawing = 'analytic_drawing',
  anime_portrait = 'anime_portrait',
  cinematographic_style = 'cinematographic_style',
  coloring_book = 'coloring_book',
  dark_fantasy = 'dark_fantasy',
  diagrammatic_drawing = 'diagrammatic_drawing',
  diagrammatic_portrait = 'diagrammatic_portrait',
  double_exposure = 'double_exposure',
  dripping_art = 'dripping_art',
  futuristic_style = 'futuristic_style',
  graffiti_portrait = 'graffiti_portrait',
  infographic_drawing = 'infographic_drawing',
  iridescent = 'iridescent',
  isometric_anime = 'isometric_anime',
  isometric_illustration = 'isometric_illustration',
  japanese_ink = 'japanese_ink',
  one_line_drawing = 'one_line_drawing',
  op_art = 'op_art',
  ornamental_watercolor = 'ornamental_watercolor',
  paper_cut_craft = 'paper_cut_craft',
  paper_quilling = 'paper_quilling',
  pastel_drawing = 'pastel_drawing',
  patchwork_collage = 'patchwork_collage',
  pixel_art = 'pixel_art',
  polaroid_photo = 'polaroid_photo',
  realism_photography = 'realism_photography',
  stained_glass_portrait = 'stained_glass_portrait',
  tattoo_art = 'tattoo_art',
  two_d_illustration = 'two_d_illustration',
  typography_art = 'typography_art',
  ukiyo_e_art = 'ukiyo_e_art',
  watercolor_landscape = 'watercolor_landscape',
  winter_oil_painting = 'winter_oil_painting'
}

export enum AlertTypeEnum {
  Sessions_to_Clicks_ratio = 'Sessions_to_Clicks_ratio'
}

export enum AppOptimizationEventEnum {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  CONTENT_VIEW = 'CONTENT_VIEW',
  INITIATED_CHECKOUT = 'INITIATED_CHECKOUT',
  LEAD = 'LEAD',
  PURCHASE = 'PURCHASE',
  RATE = 'RATE'
}

export enum ApplicablePoliciesEnum {
  alcohol = 'alcohol',
  dating = 'dating',
  gambling_weight_loss_insurance_financial_services = 'gambling_weight_loss_insurance_financial_services'
}

export enum ArbOptimizationStrategyEnum {
  custom_conversion = 'custom_conversion',
  pvps_global = 'pvps_global',
  pvps_global_exact = 'pvps_global_exact',
  pvps_story = 'pvps_story',
  pvps_story_exact = 'pvps_story_exact',
  traffic = 'traffic'
}

export enum ArticleAssetTypeEnum {
  google_description = 'google_description',
  google_headline = 'google_headline',
  google_long_headline = 'google_long_headline',
  google_marketing_image = 'google_marketing_image',
  google_portrait_marketing_image = 'google_portrait_marketing_image',
  google_short_headline = 'google_short_headline',
  google_square_marketing_image = 'google_square_marketing_image'
}

export enum ArticleExpirationSettingsRuleTypeEnum {
  from_keywee_creation_date = 'from_keywee_creation_date',
  from_publish_date = 'from_publish_date'
}

export enum ArticleGoogleStatusEnum {
  enabled = 'enabled',
  paused = 'paused'
}

export enum ArticleRunStatusEnum {
  am_disabled = 'am_disabled',
  am_enabled = 'am_enabled',
  customer_disabled = 'customer_disabled'
}

export enum AssetTypeEnum {
  description = 'description',
  headline = 'headline',
  post_text = 'post_text'
}

export enum AttributionWindowEnum {
  click_1d = 'click_1d',
  click_28d = 'click_28d',
  click_28d_view_1d = 'click_28d_view_1d',
  click_7d = 'click_7d',
  default = 'default',
  view_1d = 'view_1d',
  view_28d = 'view_28d',
  view_7d = 'view_7d'
}

export enum AudienceTemplateTypeEnum {
  AudienceTemplateDefaultTargeting = 'AudienceTemplateDefaultTargeting',
  AudienceTemplateWCALookalike = 'AudienceTemplateWCALookalike'
}

export enum BudgetOptimizationStrategyEnum {
  jogger_strategy = 'jogger_strategy',
  runner_strategy = 'runner_strategy'
}

export enum CallToActionEnum {
  APPLY_NOW = 'APPLY_NOW',
  BOOK_TRAVEL = 'BOOK_TRAVEL',
  BUY_NOW = 'BUY_NOW',
  CONTACT_US = 'CONTACT_US',
  DONATE_NOW = 'DONATE_NOW',
  DOWNLOAD = 'DOWNLOAD',
  GET_OFFER = 'GET_OFFER',
  GET_QUOTE = 'GET_QUOTE',
  GET_SHOWTIMES = 'GET_SHOWTIMES',
  INSTALL_MOBILE_APP = 'INSTALL_MOBILE_APP',
  LEARN_MORE = 'LEARN_MORE',
  LISTEN_NOW = 'LISTEN_NOW',
  OPEN_LINK = 'OPEN_LINK',
  PLAY_GAME = 'PLAY_GAME',
  REQUEST_TIME = 'REQUEST_TIME',
  SAVE = 'SAVE',
  SEE_MENU = 'SEE_MENU',
  SHOP_NOW = 'SHOP_NOW',
  SIGN_UP = 'SIGN_UP',
  SUBSCRIBE = 'SUBSCRIBE',
  USE_APP = 'USE_APP',
  WATCH_MORE = 'WATCH_MORE'
}

export enum CampaignTypeEnum {
  facebook = 'facebook',
  google = 'google'
}

export enum CampaignsGoogleConfigsCampaignTypeEnum {
  demand_gen = 'demand_gen',
  display = 'display'
}

export enum CcaSettingsDescriptionModeEnum {
  autofill = 'autofill',
  blank = 'blank',
  custom = 'custom'
}

export enum CcaSettingsRequestTypeEnum {
  pending_client_review = 'pending_client_review',
  pending_client_review_and_upload = 'pending_client_review_and_upload'
}

export enum ClicksReportSourceEnum {
  ANALYTICS = 'ANALYTICS',
  FACEBOOK = 'FACEBOOK'
}

export enum ContextCardStyleEnum {
  LIST_STYLE = 'LIST_STYLE',
  PARAGRAPH_STYLE = 'PARAGRAPH_STYLE'
}

export enum CreativeApprovalEnum {
  Cancel_Customer_Approval = 'Cancel_Customer_Approval',
  Customer_Approval = 'Customer_Approval',
  Customer_Approval_And_Upload = 'Customer_Approval_And_Upload',
  Internal_Approval = 'Internal_Approval',
  Pre_Approve = 'Pre_Approve'
}

export enum CreativeReviewStatusEnum {
  approved = 'approved',
  disapproved = 'disapproved',
  internally_disapproved = 'internally_disapproved',
  need_of_client_approval = 'need_of_client_approval',
  pending = 'pending',
  pending_client_review = 'pending_client_review',
  pending_client_review_and_upload = 'pending_client_review_and_upload',
  pending_internal_approval = 'pending_internal_approval',
  rejected = 'rejected'
}

export enum CreativeSourceTypeEnum {
  keywee = 'keywee',
  non_keywee = 'non_keywee',
  none = 'none'
}

export enum CreativeStatusEnum {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  IN_PROCESS = 'IN_PROCESS',
  OVERDUE = 'OVERDUE',
  PAUSED = 'PAUSED',
  WITH_ISSUES = 'WITH_ISSUES'
}

export enum DateRangeEnum {
  LAST_14_DAYS = 'LAST_14_DAYS',
  LAST_2_DAYS = 'LAST_2_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_3_DAYS = 'LAST_3_DAYS',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LIFETIME = 'LIFETIME',
  THIS_MONTH = 'THIS_MONTH',
  THIS_WEEK_MON_TODAY = 'THIS_WEEK_MON_TODAY',
  THIS_WEEK_SUN_TODAY = 'THIS_WEEK_SUN_TODAY',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY'
}

export enum DefaultObjectiveEnum {
  APP_INSTALLS = 'APP_INSTALLS',
  CONVERSIONS = 'CONVERSIONS',
  LEAD_GENERATION = 'LEAD_GENERATION',
  LINK_CLICKS = 'LINK_CLICKS',
  PAGE_LIKES = 'PAGE_LIKES',
  POST_ENGAGEMENT = 'POST_ENGAGEMENT',
  REACH = 'REACH',
  VIDEO_VIEWS = 'VIDEO_VIEWS'
}

export enum DevicePlatformsEnum {
  desktop = 'desktop',
  mobile = 'mobile'
}

export enum DiscountTypeEnum {
  discount_percent = 'discount_percent',
  max_cpc = 'max_cpc'
}

export enum DiscountsDiscountTypeEnum {
  automatic = 'automatic',
  manual = 'manual'
}

export enum EducationStatusesEnum {
  ALL = 'ALL',
  ALUM = 'ALUM',
  ASSOCIATE_DEGREE = 'ASSOCIATE_DEGREE',
  DOCTORATE_DEGREE = 'DOCTORATE_DEGREE',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  HIGH_SCHOOL_GRAD = 'HIGH_SCHOOL_GRAD',
  IN_GRAD_SCHOOL = 'IN_GRAD_SCHOOL',
  MASTER_DEGREE = 'MASTER_DEGREE',
  PROFESSIONAL_DEGREE = 'PROFESSIONAL_DEGREE',
  SOME_COLLEGE = 'SOME_COLLEGE',
  SOME_GRAD_SCHOOL = 'SOME_GRAD_SCHOOL',
  SOME_HIGH_SCHOOL = 'SOME_HIGH_SCHOOL',
  UNDERGRAD = 'UNDERGRAD',
  UNSPECIFIED = 'UNSPECIFIED'
}

export enum ExecutionSpecEnum {
  deprecate_article = 'deprecate_article',
  pause_ad = 'pause_ad'
}

export enum ExperimentStatusEnum {
  draft = 'draft',
  failure = 'failure',
  in_progress = 'in_progress',
  success = 'success'
}

export enum ExperimentTypeEnum {
  best_sa_audience = 'best_sa_audience'
}

export enum FacebookAdStateEnum {
  ACTIVE = 'ACTIVE',
  ADSET_PAUSED = 'ADSET_PAUSED',
  ARCHIVED = 'ARCHIVED',
  CAMPAIGN_PAUSED = 'CAMPAIGN_PAUSED',
  DELETED = 'DELETED',
  DISAPPROVED = 'DISAPPROVED',
  IN_PROCESS = 'IN_PROCESS',
  KEYWEE_UNKNOWN = 'KEYWEE_UNKNOWN',
  PAUSED = 'PAUSED',
  PENDING_BILLING_INFO = 'PENDING_BILLING_INFO',
  PENDING_REVIEW = 'PENDING_REVIEW',
  PREAPPROVED = 'PREAPPROVED',
  WITH_ISSUES = 'WITH_ISSUES'
}

export enum FacebookImportRequestStatus {
  failure = 'failure',
  pending = 'pending',
  rejected = 'rejected',
  success = 'success',
  waiting_confirmation = 'waiting_confirmation'
}

export enum FacebookLeadgenFormsContextCardStyleEnum {
  LIST_STYLE = 'LIST_STYLE',
  PARAGRAPH_STYLE = 'PARAGRAPH_STYLE'
}

export enum FacebookLeadgenFormsLeadgenFormLocaleEnum {
  AR_AR = 'AR_AR',
  CS_CZ = 'CS_CZ',
  DA_DK = 'DA_DK',
  DE_DE = 'DE_DE',
  EN_GB = 'EN_GB',
  EN_US = 'EN_US',
  ES_ES = 'ES_ES',
  ES_LA = 'ES_LA',
  FI_FI = 'FI_FI',
  FR_FR = 'FR_FR',
  HE_IL = 'HE_IL',
  HI_IN = 'HI_IN',
  HU_HU = 'HU_HU',
  ID_ID = 'ID_ID',
  IT_IT = 'IT_IT',
  JA_JP = 'JA_JP',
  KO_KR = 'KO_KR',
  NB_NO = 'NB_NO',
  NL_NL = 'NL_NL',
  PL_PL = 'PL_PL',
  PT_BR = 'PT_BR',
  PT_PT = 'PT_PT',
  RO_RO = 'RO_RO',
  RU_RU = 'RU_RU',
  SV_SE = 'SV_SE',
  TH_TH = 'TH_TH',
  TR_TR = 'TR_TR',
  VI_VN = 'VI_VN',
  ZH_CN = 'ZH_CN',
  ZH_HK = 'ZH_HK',
  ZH_TW = 'ZH_TW'
}

export enum FacebookLeadgenFormsQuestionsPageQuestionTypeEnum {
  CITY = 'CITY',
  COMPANY_NAME = 'COMPANY_NAME',
  COUNTRY = 'COUNTRY',
  DOB = 'DOB',
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  FULL_NAME = 'FULL_NAME',
  GENDER = 'GENDER',
  ID_AR_DNI = 'ID_AR_DNI',
  ID_CL_RUT = 'ID_CL_RUT',
  ID_CO_CC = 'ID_CO_CC',
  ID_CPF = 'ID_CPF',
  ID_EC_CI = 'ID_EC_CI',
  ID_PE_DNI = 'ID_PE_DNI',
  JOB_TITLE = 'JOB_TITLE',
  LAST_NAME = 'LAST_NAME',
  MARITIAL_STATUS = 'MARITIAL_STATUS',
  MILITARY_STATUS = 'MILITARY_STATUS',
  PHONE = 'PHONE',
  POST_CODE = 'POST_CODE',
  PROVINCE = 'PROVINCE',
  RELATIONSHIP_STATUS = 'RELATIONSHIP_STATUS',
  STATE = 'STATE',
  STREET_ADDRESS = 'STREET_ADDRESS',
  WORK_EMAIL = 'WORK_EMAIL',
  WORK_PHONE_NUMBER = 'WORK_PHONE_NUMBER',
  ZIP = 'ZIP'
}

export enum FacebookLeadgenFormsStatusEnum {
  failure = 'failure',
  success = 'success'
}

export enum FacebookLeadgenFormsThankYouPageButtonTypeEnum {
  DOWNLOAD = 'DOWNLOAD',
  VIEW_WEBSITE = 'VIEW_WEBSITE'
}

export enum FacebookPositionsEnum {
  feed = 'feed',
  instant_article = 'instant_article',
  marketplace = 'marketplace',
  right_hand_column = 'right_hand_column',
  story = 'story'
}

export enum GenderEnum {
  female = 'female',
  male = 'male'
}

export enum GendersEnum {
  ALL = 'ALL',
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export enum GoogleStatusEnum {
  enabled = 'enabled',
  paused = 'paused',
  removed = 'removed',
  unknown = 'unknown',
  unspecified = 'unspecified'
}

export enum ImageTypeEnum {
  AiImage = 'AiImage',
  ArticleImage = 'ArticleImage',
  CreativeImage = 'CreativeImage'
}

export enum InstagramPositionsEnum {
  reels = 'reels',
  story = 'story',
  stream = 'stream'
}

export enum JoggerProfileEnum {
  arbitrage = 'arbitrage',
  aud_dev = 'aud_dev',
  lifetime_budget = 'lifetime_budget',
  one_day_click_cpa = 'one_day_click_cpa',
  one_day_click_cpa_no_tier = 'one_day_click_cpa_no_tier'
}

export enum LeadgenFormTemplateLocaleEnum {
  AR_AR = 'AR_AR',
  CS_CZ = 'CS_CZ',
  DA_DK = 'DA_DK',
  DE_DE = 'DE_DE',
  EN_GB = 'EN_GB',
  EN_US = 'EN_US',
  ES_ES = 'ES_ES',
  ES_LA = 'ES_LA',
  FI_FI = 'FI_FI',
  FR_FR = 'FR_FR',
  HE_IL = 'HE_IL',
  HI_IN = 'HI_IN',
  HU_HU = 'HU_HU',
  ID_ID = 'ID_ID',
  IT_IT = 'IT_IT',
  JA_JP = 'JA_JP',
  KO_KR = 'KO_KR',
  NB_NO = 'NB_NO',
  NL_NL = 'NL_NL',
  PL_PL = 'PL_PL',
  PT_BR = 'PT_BR',
  PT_PT = 'PT_PT',
  RO_RO = 'RO_RO',
  RU_RU = 'RU_RU',
  SV_SE = 'SV_SE',
  TH_TH = 'TH_TH',
  TR_TR = 'TR_TR',
  VI_VN = 'VI_VN',
  ZH_CN = 'ZH_CN',
  ZH_HK = 'ZH_HK',
  ZH_TW = 'ZH_TW'
}

export enum LevelEnum {
  article = 'article',
  campaign = 'campaign'
}

export enum MediaTypeEnum {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export enum MessengerPositionsEnum {
  messenger_home = 'messenger_home',
  story = 'story'
}

export enum OptimizationGoalEnum {
  APP_INSTALLS = 'APP_INSTALLS',
  LANDING_PAGE_VIEWS = 'LANDING_PAGE_VIEWS',
  LEAD_GENERATION = 'LEAD_GENERATION',
  LINK_CLICKS = 'LINK_CLICKS',
  OFFSITE_CONVERSIONS = 'OFFSITE_CONVERSIONS',
  PAGE_LIKES = 'PAGE_LIKES',
  POST_ENGAGEMENT = 'POST_ENGAGEMENT',
  REACH = 'REACH',
  THRUPLAY = 'THRUPLAY',
  TWO_SECOND_CONTINUOUS_VIDEO_VIEWS = 'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS',
  VIDEO_VIEWS = 'VIDEO_VIEWS'
}

export enum OrganicUploadSettingsCreativeCallToActionEnum {
  APPLY_NOW = 'APPLY_NOW',
  BOOK_TRAVEL = 'BOOK_TRAVEL',
  DOWNLOAD = 'DOWNLOAD',
  GET_OFFER = 'GET_OFFER',
  GET_QUOTE = 'GET_QUOTE',
  LEARN_MORE = 'LEARN_MORE',
  SIGN_UP = 'SIGN_UP',
  SUBSCRIBE = 'SUBSCRIBE'
}

export enum OrganicUploadSettingsPoliticalContentActionEnum {
  do_not_mark_as_political = 'do_not_mark_as_political',
  mark_as_political = 'mark_as_political'
}

export enum OrganicUploadSettingsTypeEnum {
  performance = 'performance',
  rss_direct = 'rss_direct',
  rss_organic = 'rss_organic'
}

export enum PostActionEnum {
  duplicate = 'duplicate',
  reuse = 'reuse'
}

export enum PostMaloneAssetTypeEnum {
  facebookHeadline = 'facebookHeadline',
  facebookPrimaryText = 'facebookPrimaryText'
}

export enum PostMaloneSavedTemplateTypeEnum {
  csv = 'csv',
  fields = 'fields'
}

export enum PostMaloneScoreSourceTypeEnum {
  manual = 'manual',
  post_malone_suggestion = 'post_malone_suggestion'
}

export enum PostMaloneSuggestionsAssetTypeEnum {
  headline = 'headline',
  post_text = 'post_text'
}

export enum PostMaloneSuggestionsLanguageEnum {
  BG = 'BG',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN_GB = 'EN_GB',
  EN_US = 'EN_US',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FR = 'FR',
  HE = 'HE',
  HU = 'HU',
  ID = 'ID',
  IT = 'IT',
  JA = 'JA',
  LT = 'LT',
  LV = 'LV',
  NL = 'NL',
  PL = 'PL',
  PT_BR = 'PT_BR',
  PT_PT = 'PT_PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SL = 'SL',
  SV = 'SV',
  TH = 'TH',
  UK = 'UK',
  VI = 'VI',
  ZH = 'ZH'
}

export enum PublisherPlatformsEnum {
  audience_network = 'audience_network',
  facebook = 'facebook',
  instagram = 'instagram',
  messenger = 'messenger'
}

export enum QuestionPageQuestionTypeEnum {
  CITY = 'CITY',
  COMPANY_NAME = 'COMPANY_NAME',
  COUNTRY = 'COUNTRY',
  DOB = 'DOB',
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  FULL_NAME = 'FULL_NAME',
  GENDER = 'GENDER',
  ID_AR_DNI = 'ID_AR_DNI',
  ID_CL_RUT = 'ID_CL_RUT',
  ID_CO_CC = 'ID_CO_CC',
  ID_CPF = 'ID_CPF',
  ID_EC_CI = 'ID_EC_CI',
  ID_PE_DNI = 'ID_PE_DNI',
  JOB_TITLE = 'JOB_TITLE',
  LAST_NAME = 'LAST_NAME',
  MARITIAL_STATUS = 'MARITIAL_STATUS',
  MILITARY_STATUS = 'MILITARY_STATUS',
  PHONE = 'PHONE',
  POST_CODE = 'POST_CODE',
  PROVINCE = 'PROVINCE',
  RELATIONSHIP_STATUS = 'RELATIONSHIP_STATUS',
  STATE = 'STATE',
  STREET_ADDRESS = 'STREET_ADDRESS',
  WORK_EMAIL = 'WORK_EMAIL',
  WORK_PHONE_NUMBER = 'WORK_PHONE_NUMBER',
  ZIP = 'ZIP'
}

export enum RelationshipStatusesEnum {
  DIVORCED = 'DIVORCED',
  ENGAGED = 'ENGAGED',
  IN_AN_OPEN_RELATIONSHIP = 'IN_AN_OPEN_RELATIONSHIP',
  IN_A_CIVIL_UNION = 'IN_A_CIVIL_UNION',
  IN_A_DOMESTIC_PARTNERSHIP = 'IN_A_DOMESTIC_PARTNERSHIP',
  IN_RELATIONSHIP = 'IN_RELATIONSHIP',
  IT_IS_COMPLICATED = 'IT_IS_COMPLICATED',
  MARRIED = 'MARRIED',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  SEPARATED = 'SEPARATED',
  SINGLE = 'SINGLE',
  WIDOWED = 'WIDOWED'
}

export enum RuleActivityEnum {
  deleted = 'deleted',
  reactivated = 'reactivated',
  triggered = 'triggered',
  updated = 'updated'
}

export enum RunnerActionTypeEnum {
  CLOSE_AD = 'CLOSE_AD',
  CLOSE_FB_CAMPAIGN = 'CLOSE_FB_CAMPAIGN',
  OPEN_AD = 'OPEN_AD',
  OPEN_FB_CAMPAIGN = 'OPEN_FB_CAMPAIGN',
  SET_BUDGET = 'SET_BUDGET'
}

export enum RunnerBlockEnum {
  budget_capping = 'budget_capping',
  budget_denormalize = 'budget_denormalize',
  capping_recovery = 'capping_recovery',
  deprecated_ads = 'deprecated_ads',
  price_responder = 'price_responder',
  scheduled_delivery_resume = 'scheduled_delivery_resume',
  scheduled_delivery_shutdown = 'scheduled_delivery_shutdown'
}

export enum RunnerProfileEnum {
  runner_profile_default = 'runner_profile_default',
  runner_profile_facebook_cbo = 'runner_profile_facebook_cbo',
  runner_profile_inactive = 'runner_profile_inactive',
  runner_profile_no_cpc = 'runner_profile_no_cpc',
  runner_profile_total_shutdown = 'runner_profile_total_shutdown'
}

export enum StatusEnum {
  disabled = 'disabled',
  enabled = 'enabled'
}

export enum StoryAudienceGroomingStatusEnum {
  audience_created = 'audience_created',
  expired = 'expired',
  failure = 'failure',
  in_progress = 'in_progress',
  pending = 'pending'
}

export enum SubLevelEnum {
  per_article = 'per_article',
  sum_of_articles = 'sum_of_articles'
}

export enum SubUseCaseEnum {
  APP_ENGAGEMENT = 'APP_ENGAGEMENT',
  APP_PURCHASES = 'APP_PURCHASES',
  BASELINE = 'BASELINE',
  CONVERSIONS = 'CONVERSIONS',
  DR_SUBSCRIPTIONS = 'DR_SUBSCRIPTIONS',
  FB_ENGAGEMENT = 'FB_ENGAGEMENT',
  IMPRESSIONS = 'IMPRESSIONS',
  OPTIMIZED_CPC = 'OPTIMIZED_CPC',
  REGISTRATION_C2C = 'REGISTRATION_C2C',
  RETENTION = 'RETENTION',
  RETURNING_GROWTH = 'RETURNING_GROWTH',
  ROI = 'ROI',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  VIDEO_VIEWS = 'VIDEO_VIEWS'
}

export enum SuggestedAudienceSourceEnum {
  ATI = 'ATI',
  FB = 'FB',
  TOP_SPENDING = 'TOP_SPENDING'
}

export enum ThankYouPageButtonTypeEnum {
  DOWNLOAD = 'DOWNLOAD',
  VIEW_WEBSITE = 'VIEW_WEBSITE'
}

export enum TrackingEventsStatusEnum {
  failure = 'failure',
  success = 'success'
}

export enum TriggerFieldEnum {
  cost_per_add_payment_info = 'cost_per_add_payment_info',
  cost_per_add_to_cart = 'cost_per_add_to_cart',
  cost_per_add_to_wishlist = 'cost_per_add_to_wishlist',
  cost_per_complete_registration = 'cost_per_complete_registration',
  cost_per_initiate_checkout = 'cost_per_initiate_checkout',
  cost_per_lead = 'cost_per_lead',
  cost_per_link_click = 'cost_per_link_click',
  cost_per_purchase = 'cost_per_purchase',
  cost_per_result = 'cost_per_result',
  cost_per_search = 'cost_per_search',
  cost_per_view_content = 'cost_per_view_content',
  impressions = 'impressions'
}

export enum UploadFreshCreativeEnum {
  DEFAULT_AUDIENCE = 'DEFAULT_AUDIENCE',
  SA_AND_DEFAULT_AUDIENCE = 'SA_AND_DEFAULT_AUDIENCE',
  SA_AUDIENCE = 'SA_AUDIENCE'
}

export enum UploadSourceTypeEnum {
  audience_advantage = 'audience_advantage',
  new_kms_ui_upload_ads = 'new_kms_ui_upload_ads',
  one_click_upload_audience_enhancement = 'one_click_upload_audience_enhancement',
  one_click_upload_creative_enhancement = 'one_click_upload_creative_enhancement',
  one_click_upload_fresh_articles = 'one_click_upload_fresh_articles',
  one_click_upload_fresh_creatives = 'one_click_upload_fresh_creatives',
  organic_upload_flow = 'organic_upload_flow',
  update_leadgen_forms_upload_ads = 'update_leadgen_forms_upload_ads'
}

export enum UseCaseEnum {
  ARBITRAGE = 'ARBITRAGE',
  AUDIENCE_DEVELOPMENT = 'AUDIENCE_DEVELOPMENT',
  BRAND_AFFILIATE = 'BRAND_AFFILIATE',
  BRAND_BRAND_AWARENESS = 'BRAND_BRAND_AWARENESS',
  BRAND_E_COMMERCE = 'BRAND_E_COMMERCE',
  BRAND_LEAD_GENERATION = 'BRAND_LEAD_GENERATION',
  OTHER = 'OTHER',
  PUB_AFFILIATE = 'PUB_AFFILIATE',
  PUB_BRANDED_CONTENT = 'PUB_BRANDED_CONTENT',
  PUB_EMAIL_SUBSCRIPTION = 'PUB_EMAIL_SUBSCRIPTION',
  PUB_E_COMMERCE = 'PUB_E_COMMERCE',
  PUB_PAID_SUBSCRIPTIONS = 'PUB_PAID_SUBSCRIPTIONS'
}

export enum UserDeviceEnum {
  android_smartphone = 'android_smartphone',
  android_tablet = 'android_tablet',
  ipad = 'ipad',
  iphone = 'iphone'
}

export enum UserOsEnum {
  android = 'android',
  iOS = 'iOS'
}

export enum VideoSourceEnum {
  ACCOUNT = 'ACCOUNT',
  MANUAL = 'MANUAL',
  PAGE = 'PAGE'
}

export enum CreationMethodEnum {
  ASSIGN_TEMPLATE = 'ASSIGN_TEMPLATE',
  CCA_ANYWORD = 'CCA_ANYWORD',
  CCA_LEGACY = 'CCA_LEGACY',
  CCA_QUOTES = 'CCA_QUOTES',
  DUPLICATE_FROM_POST = 'DUPLICATE_FROM_POST',
  MANUAL = 'MANUAL',
  ORGANIC_UPLOAD_DUPLICATE = 'ORGANIC_UPLOAD_DUPLICATE',
  ORGANIC_UPLOAD_PHOTO_POST = 'ORGANIC_UPLOAD_PHOTO_POST',
  ORGANIC_UPLOAD_SUGGESTED = 'ORGANIC_UPLOAD_SUGGESTED'
}

export enum TextAssetSourceEnum {
  ANYWORD_QUOTE = 'ANYWORD_QUOTE',
  ANYWORD_SAVED_TEMPLATE = 'ANYWORD_SAVED_TEMPLATE',
  ANYWORD_SUGGESTION = 'ANYWORD_SUGGESTION',
  ARTICLE_DESCRIPTION = 'ARTICLE_DESCRIPTION',
  ARTICLE_TITLE = 'ARTICLE_TITLE',
  BLANK = 'BLANK',
  FACEBOOK_POST_HEADLINE = 'FACEBOOK_POST_HEADLINE',
  FACEBOOK_POST_MESSAGE = 'FACEBOOK_POST_MESSAGE',
  MANUAL = 'MANUAL'
}

export interface AccountInput {
  googleAccountId: string;
  googleAccountName: string;
  timeZone: string;
}

export interface AccountManagerInput {
  id: string;
  email: string;
}

export interface AccountsOverviewCampaignInput {
  end?: string | null;
  goalCpa?: number | null;
  dailyMonitorBudget?: number | null;
}

export interface AdGroupsFilterInput {
  dateRange: DateRangeInput;
  publisherIds?: string[] | null;
  campaignIds?: string[] | null;
  articleIds?: string[] | null;
  googleAdGroupIds?: string[] | null;
}

export interface AdInsightsFilterInput {
  dateRange: DateRangeInput;
  publisherIds?: string[] | null;
  campaignIds: string[];
  articleIds?: string[] | null;
  creativeIds?: string[] | null;
  adSetIds?: string[] | null;
  adIds?: string[] | null;
}

export interface AdSetsFilterInput {
  dateRange: DateRangeInput;
  publisherIds?: string[] | null;
  campaignIds?: string[] | null;
  articleIds?: string[] | null;
  creativeIds?: string[] | null;
  adSetIds?: string[] | null;
}

export interface AdsFilterInput {
  dateRange: DateRangeInput;
  publisherIds?: string[] | null;
  campaignIds?: string[] | null;
  articleIds?: string[] | null;
  googleAdGroupIds?: string[] | null;
  googleAdIds?: string[] | null;
}

export interface AlertInput {
  id: string;
  notes: string;
}

export interface AllArticlesFilterInput {
  search?: string | null;
  campaignObjective?: string | null;
  nonDeprecated?: boolean | null;
  withDiscountSettings?: boolean | null;
  campaignIds?: string[] | null;
  publisherIds?: string[] | null;
  articleIds?: string[] | null;
}

export interface AllCampaignsFilterInput {
  publisherIds?: number[] | null;
  active?: boolean | null;
  saEnabled?: boolean | null;
  search?: string | null;
  campaignObjective?: string | null;
}

export interface ArticleDataInput {
  leadgenFormName: string;
  articleId: string;
}

export interface ArticleExpirationSettingsExpirationRulesInput {
  id?: string | null;
  duration?: number | null;
  utmKey?: string | null;
  utmValue?: string | null;
}

export interface ArticleExpirationSettingsInput {
  id?: string | null;
  enabled?: boolean | null;
  defaultDuration?: number | null;
  ruleType?: ArticleExpirationSettingsRuleTypeEnum | null;
  expirationRulesAttributes?: ArticleExpirationSettingsExpirationRulesInput[] | null;
}

export interface ArticleGroupInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
}

export interface ArticlesFilterInput {
  dateRange: DateRangeInput;
  publisherIds?: string[] | null;
  campaignIds?: string[] | null;
  articleIds?: string[] | null;
  showNotSpending?: boolean | null;
}

export interface AssetInput {
  type: ArticleAssetTypeEnum;
  value?: string | null;
  image?: any | null;
}

export interface AudienceTemplateInput {
  id: number;
  type: AudienceTemplateTypeEnum;
}

export interface AudiencesInput {
  interests?: IdNameInput[] | null;
  customAudiences?: IdNameInput[] | null;
  excludedCustomAudiences?: IdNameInput[] | null;
  locales?: number[] | null;
  geoLocations?: GeoLocationInput | null;
  income?: IdNameInput[] | null;
  familyStatuses?: IdNameInput[] | null;
  ageMin?: number | null;
  ageMax?: number | null;
  genders?: GendersEnum[] | null;
  workPositions?: IdNameInput[] | null;
  workEmployers?: IdNameInput[] | null;
  educationMajors?: IdNameInput[] | null;
  educationSchools?: IdNameInput[] | null;
  educationStatuses?: EducationStatusesEnum[] | null;
  userDevice?: string[] | null;
  userOs?: string[] | null;
  relationshipStatuses?: RelationshipStatusesEnum[] | null;
  flexibleSpec?: FlexibleSpecInput[] | null;
}

export interface BillingCenterInput {
  id?: string | null;
  enabled: boolean;
  instances: string[];
}

export interface BindingParamsInput {
  name: string;
  followUpActionUrl: string;
  thankYouPageWebsiteUrl: string;
  trackingParameters: KeyValueInput[];
}

export interface CampaignFacebookPageInput {
  facebookPageId: any;
  facebookPageDisplayName: string;
  instagramAccountType?: string | null;
  instagramAccountId?: any | null;
  newPageExperience?: boolean | null;
}

export interface CampaignsCreateGoogleConfigInput {
  campaignType: CampaignsGoogleConfigsCampaignTypeEnum;
  startDate: any;
  endDate: any;
  dailyBudget: number;
  bid?: number | null;
  defaultGoogleCampaignDailyBudget: number;
  businessName: string;
  urlParams?: string | null;
  minAge: number;
  maxAge?: number | null;
  includeUndeterminedAge: boolean;
  genders: GenderEnum[];
  includeUndeterminedGender: boolean;
  targetedLocations: GeoTargetConstantInput[];
  campaignsGoogleLogos: CampaignsGoogleLogoInput[];
}

export interface CampaignsFilterInput {
  dateRange?: DateRangeInput | null;
  publisherIds?: string[] | null;
  campaignIds: string[];
}

export interface CampaignsGoogleLogoInput {
  id?: string | null;
  file?: any | null;
}

export interface CampaignsUpdateGoogleConfigInput {
  endDate: any;
  dailyBudget: number;
  bid?: number | null;
  defaultGoogleCampaignDailyBudget: number;
  businessName: string;
  urlParams?: string | null;
  minAge: number;
  maxAge?: number | null;
  includeUndeterminedAge: boolean;
  genders: GenderEnum[];
  includeUndeterminedGender: boolean;
  targetedLocations: GeoTargetConstantInput[];
  campaignsGoogleLogos: CampaignsGoogleLogoInput[];
}

export interface CarouselAssetSpecsInput {
  callToAction?: CallToActionEnum | null;
  name?: string | null;
  description?: string | null;
  videoId?: string | null;
  picture?: string | null;
  link: string;
}

export interface CarouselCreativeInput {
  message?: string | null;
  carouselAssetSpecs?: CarouselAssetSpecsInput[] | null;
  callToAction?: CallToActionEnum | null;
  sourceType: CreativeSourceTypeEnum;
}

export interface CcaSettingsInput {
  automaticCreativeCreation: boolean;
  automaticApprovalRequest: boolean;
  automaticApprovalRequestType: string;
  postTextHashtagsEnabled?: boolean | null;
  postTextHashtags?: string | null;
}

export interface CommonDiscountSettingsInput {
  id?: string | null;
  enabled: boolean;
  discountType: DiscountTypeEnum;
  discountValue?: number | null;
}

export interface ContextCardContentInput {
  value: TextAssetInput;
}

export interface ContextCardInput {
  title: TextAssetInput;
  style: ContextCardStyleEnum;
  contents: ContextCardContentInput[];
}

export interface CreateExperimentDraftInput {
  name: string;
  type: ExperimentTypeEnum;
  lifetimeBudget: number;
  endTime: any;
  creativeIds: number[];
  audienceTemplates: AudienceTemplateInput[];
}

export interface CreateGoogleCampaignInput {
  name: string;
  publisherId: string;
  accountManagerId: string;
  googleConfig: CampaignsCreateGoogleConfigInput;
}

export interface CreativeTemplatePreviewInput {
  mediaType?: MediaTypeEnum | null;
  imageUrl?: string | null;
  videoId?: string | null;
  postText?: string | null;
  headline?: string | null;
  description?: string | null;
  callToAction?: CallToActionEnum | null;
  carouselAssetSpecs?: CarouselAssetSpecsInput[] | null;
}

export interface CustomDisclaimerCheckboxInput {
  isRequired: boolean;
  isCheckedByDefault: boolean;
  text: TextAssetInput;
}

export interface CustomDisclaimerInput {
  title: TextAssetInput;
  bodyText: TextAssetInput;
  urlEntities: CustomDisclaimerURLEntityInput[];
  checkboxes: CustomDisclaimerCheckboxInput[];
}

export interface CustomDisclaimerURLEntityInput {
  url: string;
  length: number;
  offset: number;
}

export interface DateRangeInput {
  startDate: any;
  endDate: any;
}

export interface ExperimentsFilterInput {
  requestedById: number;
}

export interface FacebookAccountInput {
  id?: number | null;
  name?: string | null;
  accountId?: string | null;
  businessIdType?: string | null;
}

export interface FacebookAccountsFilterInput {
  search: string;
  limit: number;
}

export interface FacebookAdsFilterInput {
  dateRange: DateRangeInput;
  publisherIds?: string[] | null;
  campaignIds?: string[] | null;
  articleIds?: string[] | null;
  creativeIds?: string[] | null;
  adSetIds?: string[] | null;
  adIds?: string[] | null;
}

export interface FacebookCampaignParams {
  publisherId?: number | null;
  name: string;
  start: string;
  end: string;
  useCase: UseCaseEnum;
  subUseCase?: SubUseCaseEnum | null;
  dsaPayor?: string | null;
  dsaBeneficiary?: string | null;
  defaultFacebookAccountId?: number | null;
  autoTargetingEnabled?: boolean | null;
  fee?: number | null;
  tier?: number | null;
  billingCenter?: string | null;
  whitelistDomains: string;
  defaultAdConversionDomain?: string | null;
  defaultLeadgenTrackingParams?: any | null;
  utmParameters: string;
  adMacroTags?: string | null;
  whitelistedUrlParams?: string | null;
  urlSegment?: string | null;
  allowUrlRedirects?: boolean | null;
  allowUtmParamWithoutValue?: boolean | null;
  campaignFacebookPages: CampaignFacebookPageInput[];
  dynamicAudienceUpload?: number | null;
  targetingExpansionEnabled?: boolean | null;
  shouldDeleteOldAds?: boolean | null;
  automaticWcaCreationEnabled?: boolean | null;
  dynamicWcaExclusionEnabled?: boolean | null;
  tagBrandPage?: any | null;
  productCatalogId?: any | null;
  reachFrequencyCapResetPeriodDays?: number | null;
  unifiedConversionPixel?: any | null;
  unifiedTrackingPixels?: any[] | null;
  facebookAppId?: any | null;
  appStoreUrl?: string | null;
  defaultObjective?: string | null;
  optimizationGoal?: string | null;
  defaultArbitrageOptimizationStrategy?: string | null;
  appOptimizationEvent?: string | null;
  defaultArbitragePageViewsPerSessionGoal?: number | null;
  budgetOptimizationStrategy?: BudgetOptimizationStrategyEnum | null;
  runnerProfile?: RunnerProfileEnum | null;
  joggerProfile?: JoggerProfileEnum | null;
  goalCpa: number;
  cpaRiskFactor: number;
  maxCpa: number;
  dailyMonitorBudget: number;
  defaultArticleDailyBudget?: number | null;
  runnerDailyBreachMargin: number;
  runnerLimitMaxBudget?: boolean | null;
  runnerMonitorArticleCapChange?: boolean | null;
  runnerResetBudgetOnRecovery?: boolean | null;
  autoBudgetSpread?: boolean | null;
  autoBidChange?: boolean | null;
  scheduledDeliveryEnabled?: boolean | null;
  scheduledDeliveryStartTime?: string | null;
  scheduledDeliveryEndTime?: string | null;
  defaultDailyBudget: number;
  bidStrategy: string;
  defaultActionsBid?: number | null;
  automaticAdPlacementEnabled?: boolean | null;
  defaultPlacementPublisherPlatforms?: PublisherPlatformsEnum[] | null;
  defaultPlacementDevicePlatforms?: DevicePlatformsEnum[] | null;
  defaultPlacementFacebookPositions?: FacebookPositionsEnum[] | null;
  defaultPlacementInstagramPositions?: InstagramPositionsEnum[] | null;
  defaultPlacementMessengerPositions?: MessengerPositionsEnum[] | null;
  defaultUserOs?: UserOsEnum[] | null;
  defaultUserDevice?: UserDeviceEnum[] | null;
  savedAudienceId?: string | null;
  useSavedAudience?: boolean | null;
  defaultAgeMin: number;
  defaultAgeMax: number;
  defaultGender?: number | null;
  language: string;
  defaultLocalesFromLanguage?: boolean | null;
  defaultCountries?: string[] | null;
  defaultRegions?: any[] | null;
  defaultMediumGeoAreas?: any[] | null;
  defaultCities?: any[] | null;
  defaultZipCodes?: any[] | null;
  defaultBehaviors?: any[] | null;
  defaultCustomAudiences?: any[] | null;
  excludedCustomAudiences?: any[] | null;
  defaultRelationshipStatuses?: number[] | null;
  storyAudienceCampaignSettingAttributes?: StoryAudienceCampaignSettingsInput | null;
  audienceAdvantageEnabled?: boolean | null;
  facebookConversionFields?: string[] | null;
  dailyGraphFields?: string[] | null;
  keyweeConversionFields?: string[] | null;
  externalConversionFields?: string[] | null;
  reportBreakdownOptions?: string[] | null;
  attributionWindow?: string | null;
  dailyConversionGraph?: string | null;
  clicksReportSource: ClicksReportSourceEnum;
  externalArchived: boolean;
  kssKeyweeCreativesLiftMetricEnabled: boolean;
  kssKeyweeCreativesLiftMetricConversionId: string;
  goal: string;
  defaultGoalAttributionWindow: string;
  targetGoalType: string;
  targetGoalValue?: number | null;
  goalDescription: string;
  targetDailySpend?: number | null;
  isHugoOn?: boolean | null;
  clientFeedbackResolution?: string | null;
  clientFeedbackKind?: string | null;
  goalCppvDollars?: number | null;
  clientFeedbackSource?: string | null;
  goalProfitMargin?: number | null;
  goalCpcTopDollars?: number | null;
  goalCpcBottomDollars?: number | null;
  hugoImportBufferEnabled?: boolean | null;
  hugoImportBuffer?: number | null;
  contentDataSourceIds?: string[] | null;
  creativeApprovalIsEnabled?: boolean | null;
  pageLockedArticlesEnabled?: boolean | null;
  unassignedArticlesFacebookPageId?: any | null;
  facebookPageTrackingParams?: FacebookPageTrackingParamInput[] | null;
  urlValidationBypass?: string[] | null;
  articleExpirationSettingsAttributes?: ArticleExpirationSettingsInput | null;
  organicUploadSettingsAttributes?: OrganicUploadSettingsInput | null;
  discountSettingsAttributes: CommonDiscountSettingsInput;
}

export interface FacebookImportRequestsFilterInput {
  requestedById: number;
}

export interface FacebookLeadgenFormInput {
  blockDisplayForNonTargetedViewer?: boolean | null;
  isOptimizedForQuality?: boolean | null;
  locale?: FacebookLeadgenFormsLeadgenFormLocaleEnum | null;
  privacyPolicy?: FacebookLeadgenFormsPrivacyPolicyInput | null;
  thankYouPage?: FacebookLeadgenFormsThankYouPageInput | null;
  questionsPage?: FacebookLeadgenFormsQuestionsPageInput | null;
  contextCard?: FacebookLeadgenFormsContextCardInput | null;
  customDisclaimer?: FacebookLeadgenFormsCustomDisclaimerInput | null;
  trackingParametersOptions?: FacebookLeadgenFormsTrackingParametersInput | null;
}

export interface FacebookLeadgenFormsContextCardContentInput {
  value: string;
}

export interface FacebookLeadgenFormsContextCardInput {
  title?: string | null;
  style?: FacebookLeadgenFormsContextCardStyleEnum | null;
  contents?: FacebookLeadgenFormsContextCardContentInput[] | null;
  delete?: boolean | null;
}

export interface FacebookLeadgenFormsCustomDisclaimerCheckboxInput {
  isRequired: boolean;
  isCheckedByDefault: boolean;
  text: string;
  key: string;
}

export interface FacebookLeadgenFormsCustomDisclaimerInput {
  title?: string | null;
  bodyText?: string | null;
  urlEntities?: FacebookLeadgenFormsCustomDisclaimerURLEntityInput[] | null;
  checkboxes?: FacebookLeadgenFormsCustomDisclaimerCheckboxInput[] | null;
  deleteDisclaimer?: boolean | null;
  deleteDisclaimerCheckboxes?: boolean | null;
}

export interface FacebookLeadgenFormsCustomDisclaimerURLEntityInput {
  url: string;
  length: number;
  offset: number;
}

export interface FacebookLeadgenFormsPrivacyPolicyInput {
  linkText: string;
  url: string;
}

export interface FacebookLeadgenFormsQuestionsPageCustomQuestionInput {
  label: string;
  key: string;
  type: string;
  options?: FacebookLeadgenFormsQuestionsPageCustomQuestionOptionInput[] | null;
}

export interface FacebookLeadgenFormsQuestionsPageCustomQuestionOptionInput {
  value: string;
}

export interface FacebookLeadgenFormsQuestionsPageInput {
  questionsPageCustomHeadline?: string | null;
  questions?: FacebookLeadgenFormsQuestionsPageQuestionInput[] | null;
  customQuestions?: FacebookLeadgenFormsQuestionsPageCustomQuestionInput[] | null;
}

export interface FacebookLeadgenFormsQuestionsPageQuestionInput {
  type: FacebookLeadgenFormsQuestionsPageQuestionTypeEnum;
  key: string;
}

export interface FacebookLeadgenFormsThankYouPageInput {
  title: string;
  body: string;
  buttonText: string;
  buttonType: FacebookLeadgenFormsThankYouPageButtonTypeEnum;
}

export interface FacebookLeadgenFormsTrackingParametersInput {
  trackingParameters?: KeyValueInput[] | null;
  delete?: boolean | null;
}

export interface FacebookPageInput {
  id: string;
  name: string;
  externalId: string;
  newPageExperience: boolean;
}

export interface FacebookPageTrackingParamInput {
  facebookPageId: any;
  key?: string | null;
  value?: string | null;
}

export interface FlexibleSpecInput {
  behaviors?: IdNameInput[] | null;
  customAudiences?: IdNameInput[] | null;
}

export interface GeoLocationInput {
  countries?: string[] | null;
  zips?: KeyNameInput[] | null;
  cities?: KeyNameInput[] | null;
  regions?: KeyNameInput[] | null;
  mediumGeoAreas?: KeyNameInput[] | null;
}

export interface GeoTargetConstantInput {
  id: string;
  canonicalName: string;
  targetType: string;
}

export interface IdNameInput {
  id: string;
  name: string;
}

export interface ImageOrVideoCreativeInput {
  postText?: string | null;
  headline?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  videoId?: string | null;
  callToAction?: CallToActionEnum | null;
  sourceType: CreativeSourceTypeEnum;
}

export interface ImageOrVideoCreativeTemplateUpdateInput {
  id: string;
  sourceType?: CreativeSourceTypeEnum | null;
  callToAction?: CallToActionEnum | null;
  postText?: TextAssetInput | null;
  headline?: TextAssetInput | null;
  description?: TextAssetInput | null;
  imageId?: number | null;
  imageType?: ImageTypeEnum | null;
}

export interface JobsCreativesCreateJobsArticleInput {
  articleId: string;
  campaignFacebookPageIds: string[];
  leadgenFormId?: string | null;
}

export interface JobsCreativesCreateJobsCreativeInput {
  carouselCreativeInput?: CarouselCreativeInput[] | null;
  imageOrVideoCreativeInput?: ImageOrVideoCreativeInput[] | null;
}

export interface KeyNameInput {
  key: string;
  name: string;
  radius?: number | null;
  distanceUnit?: string | null;
}

export interface KeyValueInput {
  key: string;
  value: string;
}

export interface KeyweeFeedArticlesFilterInput {
  urls?: string[] | null;
  domains?: string[] | null;
  startDate?: any | null;
  endDate?: any | null;
  facebookPageExternalIds?: string[] | null;
  rssFeedUrls?: string[] | null;
  search?: string | null;
  sort?: string | null;
  page?: number | null;
  perPage?: number | null;
}

export interface KeyweeFeedFacebookPostsInput {
  urls?: string[] | null;
}

export interface KwTableSettingColumnInput {
  colId: string;
  hide: boolean;
  pinned?: any | null;
  width?: number | null;
}

export interface KwTableSettingInput {
  tableName: string;
  config: KwTableSettingColumnInput[];
}

export interface LeadgenFormDataInput {
  leadgenFormName: string;
  leadgenFormId: string;
}

export interface LeadgenFormTemplateInput {
  id?: string | null;
  name: TextAssetInput;
  blockDisplayForNonTargetedViewer: boolean;
  isOptimizedForQuality: boolean;
  locale: LeadgenFormTemplateLocaleEnum;
  privacyPolicy: PrivacyPolicyInput;
  thankYouPage: ThankYouPageInput;
  questionPage: QuestionPageInput;
  contextCard?: ContextCardInput | null;
  customDisclaimer?: CustomDisclaimerInput | null;
}

export interface OrganicUploadSettingsInput {
  id?: string | null;
  enabled?: boolean | null;
  type?: string | null;
  maxArticlesToUpload?: number | null;
  enableCreativeApproval?: boolean | null;
  enableCreativeSuggestions?: boolean | null;
  maxCreativeSuggestions?: number | null;
  excludeTaggedSponsoredPosts?: boolean | null;
  enablePoliticalContent?: boolean | null;
  politicalContentAction?: OrganicUploadSettingsPoliticalContentActionEnum | null;
  enablePhotoPosts?: boolean | null;
  enableLeadgenFormCreation?: boolean | null;
  enableLeadgenFormNamePrefix?: boolean | null;
  enableLeadgenFormNameSuffix?: boolean | null;
  leadgenFormExternalId?: string | null;
  creativeCallToAction?: OrganicUploadSettingsCreativeCallToActionEnum | null;
  leadgenFormNamePrefix?: string | null;
  leadgenFormNameSuffix?: string | null;
  rssSettings?: OrganicUploadSettingsRssSettingsInput[] | null;
  whitelistEnabled?: boolean | null;
  whitelistedWords?: string[] | null;
  blacklistEnabled?: boolean | null;
  blacklistedWords?: string[] | null;
}

export interface OrganicUploadSettingsRssSettingsInput {
  url: string;
  startDate: any;
}

export interface PixelTrackingAppsFilterInput {
  search?: string | null;
}

export interface PostMaloneProjectArticleBriefInput {
  title: string;
  body: string;
}

export interface PrivacyPolicyInput {
  linkText: TextAssetInput;
  url: string;
}

export interface PublisherFacebookAccountInput {
  priority: number;
  accountHasAds?: boolean | null;
  facebookAccount: FacebookAccountInput;
}

export interface PublisherFacebookPageInput {
  instagramAccountType?: string | null;
  instagramAccountId?: number | null;
  facebookPage?: FacebookPageInput | null;
}

export interface QuestionPageCustomQuestionInput {
  label: TextAssetInput;
  options?: QuestionPageCustomQuestionOptionInput[] | null;
}

export interface QuestionPageCustomQuestionOptionInput {
  value: TextAssetInput;
}

export interface QuestionPageInput {
  questionPageCustomHeadline: TextAssetInput;
  questions?: QuestionPageQuestionInput[] | null;
  customQuestions?: QuestionPageCustomQuestionInput[] | null;
}

export interface QuestionPageQuestionInput {
  type: QuestionPageQuestionTypeEnum;
}

export interface RetroDiscountsInput {
  discountPercent: number;
  articleId: string;
  date: any;
}

/**
 * Input for creating or updating rules
 */
export interface RulesInput {
  id?: string | null;
  name: string;
  level: LevelEnum;
  subLevel?: SubLevelEnum | null;
  status: StatusEnum;
  goal: number;
  minSpend?: number | null;
  triggerField: TriggerFieldEnum;
  dateRange: DateRangeEnum;
  attributionWindow?: AttributionWindowEnum | null;
  articleIds?: string[] | null;
  campaignId: string;
}

export interface RunnerDecisionsFilterInput {
  block?: RunnerBlockEnum | null;
  actionType?: RunnerActionTypeEnum | null;
  search?: string | null;
}

export interface SelfServiceSettingsInput {
  enabled: boolean;
}

export interface SortInput {
  order: string;
  orderBy: string;
}

export interface StoryAudienceArticleGroomingsInput {
  articleId: number;
  audienceTemplateId: number;
  audienceTemplateType: AudienceTemplateTypeEnum;
}

export interface StoryAudienceCampaignSettingsInput {
  id?: number | null;
  campaignEnabled?: boolean | null;
  wcaLookalikeEnabled?: boolean | null;
  fresherWcaLookalikeEnabled?: boolean | null;
  defaultTargetingEnabled?: boolean | null;
  lookalikeAudienceSize?: number | null;
  lastUploadTime?: string | null;
}

export interface TargetingSelectionInput {
  ageMin?: number | null;
  ageMax?: number | null;
  relationshipStatuses?: RelationshipStatusesEnum[] | null;
}

export interface TextAssetInput {
  id?: string | null;
  text?: string | null;
}

export interface ThankYouPageInput {
  title: TextAssetInput;
  body: TextAssetInput;
  buttonText: TextAssetInput;
  buttonType: ThankYouPageButtonTypeEnum;
}

export interface UISettingsConfigCampaignInput {
  campaignId: string;
  campaignName: string;
}

export interface UISettingsConfigInput {
  publisherId: string;
  publisherName: string;
  campaigns?: UISettingsConfigCampaignInput[] | null;
}

export interface UpdateArticleInput {
  id: string;
  url: string;
  title?: string | null;
  addtionalParameters?: string | null;
  manualExpirationTime?: string | null;
  targetingSelection?: TargetingSelectionInput | null;
  budgetCapDollars?: number | null;
  goalCpcDollars?: number | null;
  deprecated?: boolean | null;
  starred?: boolean | null;
  isPolitical?: boolean | null;
  specialAdCategories?: string[] | null;
  applicablePolicies?: ApplicablePoliciesEnum[] | null;
  discountSettingsAttributes?: CommonDiscountSettingsInput | null;
  facebookPageId?: any | null;
}

export interface UpdateGoogleCampaignInput {
  id: string;
  name: string;
  accountManagerId: string;
  googleConfig: CampaignsUpdateGoogleConfigInput;
}

export interface SsoConfigurationInput {
  idpEntityId: string;
  idpSsoUrl: string;
  idpCertificate: string;
}

export interface UpdatePublisherInput {
  id: number;
  email: string;
  temporaryHandoff: boolean;
  accountManager?: AccountManagerInput | null;
  accountSupervisor?: AccountManagerInput | null;
  temporaryAccountManager?: AccountManagerInput | null;
  active: boolean;
  contentEnhancerEnabled: boolean;
  enableAiImagesGeneration: boolean;
  enablePauseArticlesInKss: boolean;
  showStoryUrlAndSpendStatusInKss?: boolean | null;
  pageLockedArticlesEnabled?: boolean | null;
  dashboardAccessRestricted: boolean;
  billingCenter?: BillingCenterInput | null;
  selfServiceSettings?: SelfServiceSettingsInput | null;
  facebookPages?: PublisherFacebookPageInput[] | null;
  customUserAgent?: string | null;
  facebookPixelId?: string | null;
  publisherFacebookAccounts?: PublisherFacebookAccountInput[] | null;
  googleAccount?: AccountInput | null;
  ssoEnabled?: boolean | null;
  ssoConfiguration?: SsoConfigurationInput | null;
}

export interface TriggerCcaRunSettingsOverrideInput {
  automaticApprovalRequest?: boolean | null;
  automaticApprovalRequestType?: CcaSettingsRequestTypeEnum | null;
  postTextHashtagsEnabled?: boolean | null;
  postTextHashtags?: string | null;
  descriptionMode?: CcaSettingsDescriptionModeEnum | null;
  customDescription?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
